module.exports = __webpack_public_path__ + "img/RV.1d8e49b6.png";